import ArticleInfo from '@/components/BlogComponents/shared/ArticleInfo/ArticleInfo';
import BlogTag from '@/components/BlogComponents/shared/BlogTag/BlogTag';
import ResponsiveImage from '@/components/Image/ResponsiveImage';
import Link from '@/components/Link/Link';
import type { BlogPageType } from '@/contentful/api/api.types';
import useGlobalStyles from '@/styles/global.styles';
import { brandColors } from '@/styles/theme/values/brandColors';

import useStyles from './BlogCuratedArticleSquareCard.styles';

export default function BlogCuratedArticleSquareCard({
  featuredArticle,
}: {
  featuredArticle: BlogPageType;
}) {
  const { classes, cx } = useStyles();
  const { classes: globalClasses } = useGlobalStyles({ fixed: true });
  const {
    heroImage,
    heroImageAltText,
    blogTitle,
    category,
    categoryPath,
    readTimeMinutes,
    path,
  } = featuredArticle;

  return (
    <div className={classes.wrapper}>
      {heroImage?.[0] && (
        <Link className={classes.imageWrapper} href={path}>
          <ResponsiveImage
            src={heroImage[0]}
            alt={heroImageAltText || ''}
            className={classes.image}
            sizes={{ xs: 600 }}
          />
        </Link>
      )}

      <div className={classes.detailsWrapper}>
        <div className={classes.headingAndDateWrapper}>
          <h3 className={cx(globalClasses.h3, classes.heading)}>
            <Link href={path} title={blogTitle}>
              {blogTitle}
            </Link>
          </h3>
          <div className={classes.dateAndCategoryWrapper}>
            <ArticleInfo
              readingTime={readTimeMinutes}
              textColor={brandColors.white}
            />
            {category && categoryPath && (
              <BlogTag category={category} path={categoryPath} />
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
